module.exports = __webpack_public_path__ + "assets/img/de-c8f3f2ac.png";